export default "__VITE_ASSET__DCumpC2Y__"